import styled from "@emotion/styled";
import { Affix, Button, Tooltip } from "antd";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useBankListTotals } from "hooks/useBankListTotals";

interface FooterBankProps {
  loading?: boolean;
}

const FooterBank: FC<FooterBankProps> = ({ loading }) => {
 const navigate = useNavigate();
  const { activeBanks, isLunganek, isLoading } = useBankListTotals();
  const addDisabled = !isLunganek && activeBanks >= 1;

  return (
    <Affix offsetBottom={0}>
      <WrapperAll>
        <ButtonWrapper>
          <Tooltip
            title={
              addDisabled
                ? "มีบัญชีที่เปิดใช้งานอยู่แล้ว ปิดการใช้งานก่อนจึงจะเพิ่มบัญชีใหม่ได้"
                : undefined
            }
          >
            <Button
            htmlType="submit"
            type="primary"
            style={{ width: 200 }}
            size="large"
            loading={loading || isLoading}
            disabled={addDisabled}
            onClick={ ()=> {
              if (addDisabled) return;
              navigate('/manage-bank/create')
            }}
          >
            เพิ่มบัญชีใหม่
          </Button>
          </Tooltip>
        </ButtonWrapper>
      </WrapperAll>
    </Affix>
  );
};

export default FooterBank;
const ButtonWrapper = styled.div`
  max-width: 250px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const WrapperAll = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
`;
